// Import Swiper
import Swiper from 'swiper/bundle'

// Capture body and all slider elements
const body     = document.body;
const sliderElements  = document.querySelectorAll(`.js--slider`);


// Empty array of slider classes
const sliderClasses = [];

// Loop through each '.js--slider' element
sliderElements.forEach(sliderElement => {
  // Loop through the element's classes
  sliderElement.classList.forEach(elementClass => {
    // If an element's class includes 'js--slider__'
    if (elementClass.includes(`js--slider__`)) {
      // Add class to sliderClasses
      sliderClasses.push(elementClass);
    }
  });
});


// Loop through sliderClasses and init the
// corresponding Slider and Gallery
sliderClasses.forEach(sliderClass => {
  // sliderID is the slider block ID from Craft
  const sliderID  = sliderClass.replace(`js--slider__`, ``);

  // Capture the corresponding Slider and Gallery
  const slider  = document.querySelector(`.js--slider__` + sliderID);
  const gallery = document.querySelector(`.js--gallery__` + sliderID);

  // Capture Previous and Next buttons
  const prevButton = `.swiper-button-prev__` + sliderID;
  const nextButton = `.swiper-button-next__` + sliderID;


  // Capture Slider pagination
  const sliderPagination = slider.querySelector(`.swiper-pagination`);

  // Init Slider
  var sliderInstance;
  if (slider.classList.contains(`js--slider--small`)) {
    var sliderInstance = new Swiper(slider, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: false,
      slideToClickedSlide: true,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      keyboard: {
        enabled: true,
      },
    });

  } else if (slider.classList.contains(`js--slider__location`)) {
    var sliderInstance = new Swiper(slider, {
      loop: true,
      slidesPerView: "1",
      spaceBetween: 0,
      slideToClickedSlide: true,
      pauseOnMouseEnter: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,

      },
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      keyboard: {
        enabled: true,
      },
    });

    // find .swiper-button-toggle in parent and add event listener to play/pause
    const toggleButton = slider.parentNode.querySelector(`.swiper-button-toggle`);

    toggleButton.addEventListener(`click`, event => {
      if (sliderInstance.autoplay.running) {
        sliderInstance.autoplay.stop();
        toggleButton.querySelector('.swiper-button-toggle__play-icon').classList.remove('hidden');
        toggleButton.querySelector('.swiper-button-toggle__pause-icon').classList.add('hidden');
      } else {
        sliderInstance.autoplay.start();
        toggleButton.querySelector('.swiper-button-toggle__play-icon').classList.add('hidden');
        toggleButton.querySelector('.swiper-button-toggle__pause-icon').classList.remove('hidden');
      }
    });

  } else {
    var sliderInstance = new Swiper(slider, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      slideToClickedSlide: false,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      keyboard: {
        enabled: true,
      },
    });
  }


  // Capture Gallery pagination
  if (gallery === null) {
    return;
  }

  const galleryPagination = gallery.querySelector(`.swiper-pagination`);

  // Init Gallery
  var galleryInstance;
  if (slider.classList.contains(`js--gallery--small`)) {
    var galleryInstance = new Swiper(gallery, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: false,
      slideToClickedSlide: true,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: galleryPagination,
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
    });
  } else {
    var galleryInstance = new Swiper(gallery, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      slideToClickedSlide: false,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: galleryPagination,
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
    });
  }


  // Pair Slider and Gallery controls
  sliderInstance.controller.control = galleryInstance;
  galleryInstance.controller.control = sliderInstance;


  // Capture the Gallery's wrapping div and
  // open/close buttons
  const galleryWrapper     = slider.parentNode.parentNode.querySelector(`.js--gallery`);
  const openGalleryButtons = slider.querySelectorAll(`.js--gallery__open`);
  const closeGalleryButton = galleryWrapper.querySelector(`.js--gallery__close`);

  // Open the Gallery and stop autoplay
  openGalleryButtons.forEach(button => {
    button.addEventListener(`click`, event => {
      body.style.overflow = `hidden`;
      galleryWrapper.classList.add(`-is-active`);
      galleryInstance.autoplay.stop();
    });
  });

  // Close the Gallery start autoplay
  closeGalleryButton.addEventListener(`click`, event => {
    body.removeAttribute(`style`);
    galleryWrapper.classList.remove(`-is-active`);
    galleryInstance.autoplay.start()
  });
});
